"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmbClientOrderUnitType = void 0;
var SmbClientOrderUnitType;
(function (SmbClientOrderUnitType) {
    SmbClientOrderUnitType["INVALID"] = "INVALID";
    SmbClientOrderUnitType["PALLET"] = "PALLET";
    SmbClientOrderUnitType["CARTON"] = "CARTON";
    SmbClientOrderUnitType["BAG"] = "BAG";
    SmbClientOrderUnitType["BALE"] = "BALE";
    SmbClientOrderUnitType["BARREL"] = "BARREL";
    SmbClientOrderUnitType["CRATE"] = "CRATE";
    SmbClientOrderUnitType["ROLL"] = "ROLL";
    SmbClientOrderUnitType["ULD"] = "ULD";
    SmbClientOrderUnitType["PRODUCT"] = "PRODUCT";
    SmbClientOrderUnitType["PACKAGE"] = "PACKAGE";
    SmbClientOrderUnitType["BOX"] = "BOX";
    SmbClientOrderUnitType["DRUM"] = "DRUM";
    SmbClientOrderUnitType["BUNDLE"] = "BUNDLE";
    SmbClientOrderUnitType["BULK"] = "BULK";
    SmbClientOrderUnitType["TOTE"] = "TOTE";
    SmbClientOrderUnitType["SKID"] = "SKID";
    SmbClientOrderUnitType["PIECE"] = "PIECE";
    SmbClientOrderUnitType["CASE"] = "CASE";
    SmbClientOrderUnitType["PAIL"] = "PAIL";
    SmbClientOrderUnitType["SET"] = "SET";
    SmbClientOrderUnitType["BIN"] = "BIN";
    SmbClientOrderUnitType["SACK"] = "SACK";
})(SmbClientOrderUnitType = exports.SmbClientOrderUnitType || (exports.SmbClientOrderUnitType = {}));
//# sourceMappingURL=SMBBookingData.js.map